import { DataNode } from "antd/es/tree";
import { DocumentNodeTree } from "./types";

export const getBreadcrumbs = (tree: DocumentNodeTree[], currentPath: string | null): DocumentNodeTree[] => {
  if (!currentPath) return [];

  return currentPath.split("|").reduce<{ result: DocumentNodeTree[]; subtree: DocumentNodeTree[] }>(
    ({ result, subtree }, _, i, segments) => {
      const path = segments.slice(0, i + 1).join("|");
      const node = subtree.find((n) => n.treePath === path);
      return node ? { result: [...result, node], subtree: node.children } : { result, subtree: [] };
    },
    { result: [], subtree: tree },
  ).result;
};

export const findNodeByTreePath = (tree: DocumentNodeTree[], treePath: string): DocumentNodeTree | undefined =>
  tree.reduce<DocumentNodeTree | undefined>(
    (found, node) => found ?? (node.treePath === treePath ? node : findNodeByTreePath(node.children, treePath)),
    undefined,
  );

export const getNodeFoldersTree = (documentNodes: DocumentNodeTree[], omittedNodes: DocumentNodeTree[]): DataNode[] =>
  documentNodes
    .filter((node) => !node.file && !omittedNodes?.some((n) => n.id === node.id))
    .map((node) => ({
      key: node.id,
      title: node.name,
      children: getNodeFoldersTree(node.children, omittedNodes),
    }));
